import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);

const init = () => {
  const nav = document.querySelector('.site-banner');
  if (!nav) return;

  // nav tuck
  ScrollTrigger.create({
    trigger: 'body',
    start: 'top+=100 top',
    end: 'bottom top',
    toggleClass: { targets: nav, className: 'site-banner--fill' }
  });
  // end nav tuck

  const dropDowns = nav.querySelectorAll(
    'button.site-banner__navigation-item--has-sub-nav'
  );

  let activeSubNav;

  function hideSubNav() {
    dropDowns.forEach((dropDown) => {
      dropDown.setAttribute('aria-expanded', false);
    });
  }

  function handleBodyClick(e) {
    if (!activeSubNav.contains(e.target)) {
      hideSubNav();
      document.body.removeEventListener('click', handleBodyClick);
    }
  }

  function handleNav() {
    if (this.getAttribute('aria-expanded') === 'false') {
      dropDowns.forEach((dropDown) => {
        dropDown.setAttribute('aria-expanded', false);
      });

      activeSubNav = this.parentNode;

      this.setAttribute('aria-expanded', true);
      nav.classList.add('sub-nav-open');
      document.body.addEventListener('click', handleBodyClick);
    } else {
      dropDowns.forEach((dropDown) => {
        nav.classList.remove('sub-nav-open');
        dropDown.setAttribute('aria-expanded', false);
      });
    }
  }

  if (dropDowns.length > 0) {
    dropDowns.forEach((dropDown) => {
      dropDown.addEventListener('click', handleNav);
    });
  }

  const burger = nav.querySelector('.site-banner__hamburger');

  function handleBurger() {
    if (this.getAttribute('aria-expanded') === 'false') {
      this.setAttribute('aria-expanded', true);
      this.setAttribute('aria-label', 'Close navigation');
    } else {
      this.setAttribute('aria-expanded', false);
      this.setAttribute('aria-label', 'Open navigation');
    }
    dropDowns.forEach((dropDown) => {
      dropDown.setAttribute('aria-expanded', false);
    });
    nav.classList.remove('sub-nav-open');
    nav.classList.toggle('nav-open');
  }

  if (burger) {
    burger.addEventListener('click', handleBurger);
  }

  function handleMobileNavBack() {
    nav.classList.remove('sub-nav-open');
    dropDowns.forEach((dropDown) => {
      dropDown.setAttribute('aria-expanded', false);
    });
  }

  const mobileNavBackButtons = document.querySelectorAll(
    '.site-banner__mobile-sub-nav-back button'
  );

  mobileNavBackButtons.forEach((button) => {
    button.addEventListener('click', handleMobileNavBack);
  });
};

export { init };
